<style scoped>
/* Set the page size to A4 and the orientation to landscape */
@page {
  size: letter portrait;
}

/* Set the font size to 12px for printing */
@media print {
  body {
    font-size: 12px;
  }

  .page-break {
    page-break-before: always;
    counter-reset: page;
  }
}

#app {
  min-height: 0 !important;
}

#logo {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 200px;
  height: 100px;
}

.title {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

th.no-border {
  border: none;
}

.remove_border tr th {
  border: none;
}

#table-list {
  margin-top: 80px;
}

.info {
  margin-top: 20px;
  width: 40%;
  float: left;
  margin-bottom: 20px;
}

.space-for-logo {
  width: 200px;
  height: 100px;
}

#page-counter {
  display: table-footer-group;
}
</style>

<style>
#app{
  min-height: 0
}
</style>

<template>
  <div>
    <div class="page-break" :key="idx" v-for="(data, idx) in pageLength">
      <table class="" style="width: 100%">
        <thead>
          <tr class="">
            <th colspan="7">
              <div class="title">
                <p>PICKING LIST</p>
                <p>{{ data.company_name }}</p>
              </div>
            </th>
          </tr>
          <tr class="">
            <th class="py-0 w-32">Cabang</th>
            <th class="py-0 w-1">:</th>
            <th class="py-0 w-32">
              {{ data.warehouse_code }} {{ data.warehouse_name }}
            </th>
            <th class="py-0 w-32"></th>
            <th class="py-0 w-5">Print</th>
            <th class="py-0 w-1" colspan="2">: {{ data.print_counter }}</th>
          </tr>
          <tr>
            <th class="py-0 w-32">SO Document</th>
            <th class="py-0 w-1">:</th>
            <th class="py-0 w-32">{{ data.so_code }}</th>
            <th class="py-0 w-32"></th>
            <th class="py-0 w-5">Print date</th>
            <th class="py-0 w-1" colspan="2">: {{ dateNow }}</th>
          </tr>
          <tr>
            <th class="py-0 w-32">SO Date</th>
            <th class="py-0 w-1">:</th>
            <th class="py-0 w-32">{{ data.so_date }}</th>
            <th class="py-0 w-32"></th>
            <th class="py-0 w-5">Print time</th>
            <th class="py-0 w-1" colspan="2">: {{ timeNow }}</th>
          </tr>
          <tr>
            <th class="py-0 w-32">DO Document</th>
            <th class="py-0 w-1">:</th>
            <th class="py-0 w-32">{{ data.do_code }}</th>
            <th class="py-0 w-32"></th>
            <th class="py-0 w-5">Page</th>
            <th class="py-0 w-1" colspan="2"><div id="page-counter">: {{idx + 1}} of {{ pageLength.length }}</div></th>
          </tr>
          <tr>
            <th class="py-0 w-32">DO Date</th>
            <th class="py-0 w-1">:</th>
            <th class="py-0 w-32">{{ data.do_date }}</th>
            <th class="py-0 w-32"></th>
            <th class="py-0 w-5"></th>
            <th class="py-0 w-1"></th>
            <th class="py-0 w-5"></th>
          </tr>
          <tr>
            <th class="py-0 w-32">Picking Code</th>
            <th class="py-0 w-1">:</th>
            <th class="py-0 w-32">{{ data.picking_code }}</th>
            <th class="py-0 w-32"></th>
            <th class="py-0 w-5"></th>
            <th class="py-0 w-1"></th>
            <th class="py-0 w-5"></th>
          </tr>
        </thead>
      </table>

      <br />
      <div style="border-top: 1px dashed;" v-if="data.lines.length == 0"></div>
      <table class="" style="width: 100%" v-else>
        <thead>
          <tr style="border-top: 1px dashed; border-bottom: 1px dashed">
            <th style="vertical-align: middle; text-align: left">SKU Code</th>
            <th style="vertical-align: middle; text-align: left">SKU Name</th>
            <th style="vertical-align: middle; text-align: left">BATCH</th>
            <th style="vertical-align: middle; text-align: left">ED</th>
            <th style="vertical-align: middle; text-align: left">QTY</th>
            <th style="vertical-align: middle; text-align: left">UOM</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(tr, indexTr) in data.lines">
            <template v-for="(tr2, indexTr2) in tr.line_summaries">
              <tr v-bind:key="`outerTable-${indexTr}-${indexTr2}`">
                <td class="py-1">{{ tr2.sku_code }}</td>
                <td class="py-1">{{ tr2.item_name }}</td>
                <td class="py-1">{{ tr2.batch_external }}</td>
                <td class="py-1">{{ tr2.expired_date != '' ? formatDate(tr2.expired_date) : '' }}</td>
                <td class="py-1" style="text-align: right; padding-right: 15px;">{{ tr2.amount }}</td>
                <td class="py-1">{{ tr2.unit }}</td>
              </tr>
            </template>

            <template v-for="(tr3, indexTr3) in tr.line_summary_total">
              <tr
                  v-bind:key="`outerTable2-${indexTr}-${indexTr3}`"
                  style="font-weight: bold"
                  v-if="tr.line_summary_total.length > 0"
              >
                <td
                    v-if="indexTr3 == 0"
                    colspan="3"
                    :rowspan="tr.line_summary_total.length"
                ></td>
                <td
                    v-if="indexTr3 == 0"
                    class="py-1"
                    :rowspan="tr.line_summary_total.length"
                    :style="
                      indexTr3 == 0
                        ? 'text-align: center; border-top: 1px dashed'
                        : 'text-align: center;'
                    "
                >
                  Total
                </td>
                <td
                    class="py-1"
                    :style="indexTr3 == 0 ? 'border-top: 1px dashed; text-align: right; padding-right: 15px;' : 'text-align: right; padding-right: 15px;'"
                >
                  {{ tr3.quantity }}
                </td>
                <td
                    class="py-1"
                    :style="indexTr3 == 0 ? 'border-top: 1px dashed' : ''"
                >
                  {{ tr3.unit_name }}
                </td>
              </tr>
            </template>
          </template>
        </tbody>
        <tfoot>
          <tr style="border-top: 1px dashed">
            <td colspan="6"></td>
          </tr>
        </tfoot>
      </table>

      <br />
      <template v-if="idx === pageLength.length - 1">
        <template v-for="n in rowsAnother">
          <tr style="" v-bind:key="n">
            <td colspan="6">&nbsp;</td>
          </tr>
        </template>
      </template>
    </div>
    <table class="remove_border">
      <tr>
        <th style="text-align: center">Dibuat oleh</th>
        <th style="text-align: center">Disiapkan oleh</th>
        <th style="text-align: center">Diterima oleh</th>
      </tr>
      <tr>
        <th style="height: 50px"></th>
        <th style="height: 50px"></th>
        <th style="height: 50px"></th>
      </tr>
      <tr>
        <th style="text-align: center">Admin Logistic</th>
        <th style="text-align: center">Picker</th>
        <th style="text-align: center">Checker</th>
      </tr>
    </table>
  </div>
</template>

<script>
import moment from "moment-timezone";

export default {
  name: "PrintPdf",
  data() {
    return {
      doIds: null,
      picking_code: null,
      datas: [],
      dateNow: "",
      timeNow: "",
      pageLength: [],
      rowsContent: 24,
      rowsAnother: 0,
      maxCharItemName: 35,
      maxCharBatch: 21,
    };
  },
  mounted() {
    this.doIds = window.opener.doIds;
    if (this.doIds.length) {
      this.print();
    }
  },
  methods: {
    async print() {
      await this.getData();
      const tempTitle = document.title;
      await window.print();
      document.title = tempTitle;
    },
    async getData() {
      this.$vs.loading();
      let resp = await this.$http.get(
          `/api/wms/v1/simple-outbound-planner/picking-data-by-handover3`,
          { params: { do_ids: this.doIds, is_print: 1 } }
      );
      if (resp.code == 200) {
        this.datas = resp.data;
        document.title = this.datas.reduce(
            (prev, curr) => `${prev}-${curr.do_code}`,
            "picking_list"
        );
        this.formatPrintPage(this.datas)
        const now = new Date();
        this.dateNow = this.formatDate(now.setHours(now.getHours() + 7));
        this.timeNow = this.formatTime(now);
        this.$vs.loading.close();
      } else {
        this.$vs.loading.close();
      }
    },
    createPage(info) {
      return {
        ...info,
        lines: []
      }
    },
    getLineCount(line) {
      let countLines = 0

      line.line_summaries.forEach(val => {
        const itemLines = this.calculateWrappedLines(val.item_name, this.maxCharItemName)
        const batchLines = this.calculateWrappedLines(val.batch_external, this.maxCharBatch)

        countLines = countLines + Math.max(itemLines, batchLines)
      })

      return countLines + line.line_summary_total.length
    },
    canFitLine(currentCount, line) {
      return currentCount + this.getLineCount(line) <= this.rowsContent
    },
    calculateRemainingRows(lastPage) {
      let used = 1 // Header Summary

      lastPage.lines.forEach(line => {
        used += this.getLineCount(line)
      })

      let remaining = this.rowsContent - used

      if (remaining > 10) {
        remaining += 4
      }

      return remaining
    },
    calculateWrappedLines(text, maxCharPerLine) {
      if (!text) return 1

      return Math.ceil(text.length / maxCharPerLine)
    },
    formatPrintPage(data) {
      if (!data.length) {
        this.pageLength = []
        return
      }

      const info = {
        company_name: data[0].company_name,
        driver_name: data[0].driver_name,
        picking_code: data[0].picking_code,
        print_counter: data[0].print_counter,
        shipment_date: data[0].shipment_date,
        shipment_number: data[0].shipment_number,
        so_code: data[0].so_code,
        so_date: data[0].so_date,
        do_code: data[0].do_code,
        do_date: data[0].do_date,
        vehicle_number: data[0].vehicle_number,
        warehouse_code: data[0].warehouse_code,
        warehouse_name: data[0].warehouse_name
      }

      const wrapped = this.prepareWrappedData(data[0].lines)
      this.paginateLines(wrapped, info)
    },
    splitItemName(text, maxLength) {
      if (!text) return [""];

      const words = text.trim().split(/\s+/);
      const lines = [];
      let currentLine = "";

      words.forEach(word => {
        const nextLine = currentLine ? `${currentLine} ${word}` : word;

        if (nextLine.length <= maxLength) {
          currentLine = nextLine;
        } else {
          if (currentLine) {
            lines.push(currentLine);
          }

          // jika ada 1 kata lebih panjang dari maxLength
          if (word.length > maxLength) {
            for (let i = 0; i < word.length; i += maxLength) {
              lines.push(word.substring(i, i + maxLength));
            }
            currentLine = "";
          } else {
            currentLine = word;
          }
        }
      });

      if (currentLine) {
        lines.push(currentLine);
      }

      return lines;
    },
    splitBatch(text, maxLength) {
      if (!text) return [""];

      if (text.length <= maxLength) {
        return [text];
      }

      // pisahkan menjadi token beserta separatornya
      const tokens = text.match(/[^\-./\s]+|[-./]|\s+/g);

      const lines = [];
      let current = "";

      tokens.forEach(token => {
        const next = current + token;

        if (next.length <= maxLength) {
          current = next;
        } else {
          if (current) {
            lines.push(current.trimEnd());
          }

          // jika token sendiri terlalu panjang
          if (token.trim().length > maxLength) {
            const value = token.trim();

            for (let i = 0; i < value.length; i += maxLength) {
              lines.push(value.substring(i, i + maxLength));
            }

            current = "";
          } else {
            current = token.trimStart();
          }
        }
      });

      if (current) {
        lines.push(current.trimEnd());
      }

      return lines;
    },
    prepareWrappedData(lines) {
      return lines.map(line => {
        const visualSummaries = []

        line.line_summaries.forEach(summary => {
          const itemLines = this.splitItemName(summary.item_name || "", this.maxCharItemName)
          const batchLines = this.splitBatch(summary.batch_external || "", this.maxCharBatch)
          const maxLines = Math.max(itemLines.length, batchLines.length)
          const rows = []

          for (let i = 0; i < maxLines; i++) {
            rows.push({
              ...summary,
              sku_code: i === 0 ? summary.sku_code : "",
              expired_date: i === 0 ? summary.expired_date : "",
              amount: i === 0 ? summary.amount : "",
              unit: i === 0 ? summary.unit : "",
              item_name: itemLines[i] || "",
              batch_external: batchLines[i] || ""
            })
          }

          visualSummaries.push({rows})
        })

        return {
          ...line,
          visualSummaries
        }
      })
    },
    paginateLines(lines, info) {
      this.pageLength = []
      let page = this.createPage(info)
      let usedRows = 0

      for (const line of lines) {
        let currentLine = {
          ...line,
          line_summaries: [],
          line_summary_total: []
        }

        for (let s = 0; s < line.visualSummaries.length; s++) {
          const summary = line.visualSummaries[s]

          let rowIndex = 0
          let lineLength = 0
          let isLastSummary = false

          lineLength = summary.rows.length
          if (s == line.visualSummaries.length-1) {
            lineLength = summary.rows.length + line.line_summary_total.length
            isLastSummary = true
          }

          while (rowIndex < summary.rows.length) {
            const remain = this.rowsContent - usedRows
            const remainingRows = lineLength - rowIndex

            if (remainingRows <= remain) {
              // ===== summary masih muat utuh =====

              currentLine.line_summaries.push(
                ...summary.rows.slice(rowIndex)
              )

              if (isLastSummary) {
                // summary terakhir selesai
                currentLine.line_summary_total = line.line_summary_total
              }

              usedRows += remainingRows
              rowIndex = summary.rows.length
            } else {
              // ===== summary lebih besar dari halaman =====
              // kalau summary belum pernah mulai dan tidak muat utuh, pindah halaman dulu

              if (rowIndex === 0 && remain < lineLength && usedRows > 0) {
                if (currentLine.line_summaries.length) {
                  page.lines.push(currentLine)
                }

                this.pageLength.push(page)
                page = this.createPage(info)

                currentLine = {
                  ...line,
                  line_summaries: [],
                  line_summary_total: []
                }

                usedRows = 0
                continue
              }

              // ambil sebagian
              currentLine.line_summaries.push(
                ...summary.rows.slice(
                  rowIndex,
                  rowIndex + remain
                )
              )

              rowIndex += remain
              usedRows += remain
            }

            // halaman penuh
            if (usedRows >= this.rowsContent) {
              page.lines.push(currentLine)
              this.pageLength.push(page)
              page = this.createPage(info)

              currentLine = {
                ...line,
                line_summaries: [],
                line_summary_total: []
              }

              usedRows = 0
            }
          }
        }

        // semua summary selesai

        if (usedRows > this.rowsContent) {
          if (currentLine.line_summaries.length) {
            page.lines.push(currentLine)
          }

          this.pageLength.push(page)
          page = this.createPage(info)

          currentLine = {
            ...line,
            line_summaries: [],
            line_summary_total: []
          }

          usedRows = 0
        }

        if (currentLine.line_summaries.length || currentLine.line_summary_total.length) {
          page.lines.push(currentLine)
        }
      }

      if (page.lines.length) {
        this.pageLength.push(page)
      }

      // nomor halaman
      this.pageLength.forEach((page, index) => {
        page.page = index + 1
        page.totalPages = this.pageLength.length
      })

      // footer
      const remaining = this.calculateRemainingRows(this.pageLength[this.pageLength.length - 1])

      if (remaining <= 0) {
        this.rowsAnother = this.rowsContent
        this.pageLength.push(this.createPage(info))
        this.pageLength.forEach((page, index) => {
          page.page = index + 1
          page.totalPages = this.pageLength.length
        })
      } else {
        this.rowsAnother = remaining
      }
    },
  },
  computed: {
    formatDate: () => {
      return (val) => {
        const momentDate = moment.utc(val);
        return momentDate.format("DD/MM/YYYY");
      };
    },
    formatTime: () => {
      return (val) => {
        const momentDate = moment.utc(val);
        return momentDate.format("hh:mm:ss");
      };
    },
  },
};
</script>